import React from 'react';

export default function FeatureTitle({ title }) {

    return (        
        <h4>{title}</h4>
    )
}